module.exports = __webpack_public_path__ + "img/logo-light-nightskyit.ffc030a5.png";